import { useEffect, useContext, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import Utils from "../../Utils";
import axios from "axios";
import PrRequestUpload from "../../components/photographer/PrRequestUpload";
import _ from "lodash";

const PhPhotoshootDetails = (props) => {
  const { id } = useParams();
  const fileInputRef = useRef(null);
  const fileInputRefPh = useRef(null);
  const [prReadyIds, setPrReadyIds] = useState([]);
  const [filter, setFilter] = useState({ pr_status: 0 }); // 0 = No Pr, 1 = PR Requested, 2 = PR Ready
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  /* Getting status for number */
  const [status, setStatus] = useState([]);
  useEffect(() => {
    axios
      .get(Utils.apiUrl(`psstatus`), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setStatus(res.data.statuses);
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  }, []);

  /* Classes for specific status */
  const statusClasses = {
    "In-Process": "status-pill inline-block bg-yellow-100 text-yellow-800",
    Pending: "status-pill inline-block bg-pink-50 text-pink-700",
    Completed: "status-pill inline-block bg-gray-200 text-gray-700",
  };

  /* Hotel types */
  const hotel_types = {
    new: "New Property",
    converted: "Converted Property",
    established: "Established Property",
  };

  /* Handle PR Ready Change */
  const handlePrReadyChange = (photoId) => {
    setPrReadyIds((prev) => {
      if (prev.includes(photoId)) {
        // remove if unchecked
        return prev.filter((id) => id !== photoId);
      } else {
        // add if checked
        return [...prev, photoId];
      }
    });
  };

  /* Labels for status */
  const getStatusLabel = (status) => {
    const code = Number(status);

    if (code === 0 || code === 1) return "Pending";
    if (code >= 2 && code <= 6) return "In-Process";
    if (code === 7 || code === 8) return "Completed";

    return "Unknown";
  };

  /* Recce Images Listing */
  const [recceImages, setRecceImages] = useState([]);
  const updateRecceImages = () => {
    axios
      .get(Utils.apiUrl(`photoshoot/recces/${id}?limit=9999`), Utils.apiHeaders())
      .then((res) => {
        console.log(res.data);
        if (res.data.success) {
          setRecceImages(res.data.data);
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  };

  const [photoshootDetails, setPhotoshootDetails] = useState([]);
  //const [hotelDetails, setHotelDetails] = useState([]);
  useEffect(() => {
    /* Getting Photoshoot Details */
    axios
      .get(Utils.apiUrl(`photoshoot/${id}`), Utils.apiHeaders())
      .then((res) => {
        if (res.status == 200) {
          setPhotoshootDetails(res.data);
          updateRecceImages();
          updatePhotoshootImages();
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  }, []);

  const downloadAttachment = (id) => {
    axios
      .get(Utils.apiUrl(`photoshoot/attachment/${id}`), {
        responseType: "arraybuffer", // Important for binary data
        ...Utils.apiHeaders(),
      })
      .then((res) => {
        console.log(res.data);

        // Convert buffer data into file
        const bufferData = res.data;

        // Convert to Uint8Array
        const byteArray = new Uint8Array(bufferData);

        // Create a Blob (set correct MIME type from response headers)
        const blob = new Blob([byteArray], { type: res.headers["content-type"] || "application/octet-stream" });

        // Get filename from headers or default
        const contentDisposition = res.headers["content-disposition"];
        const filename = contentDisposition ? contentDisposition.split("filename=")[1]?.replace(/"/g, "") || `attachment_${id}` : `attachment_${id}`;

        // Create download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();

        // Cleanup
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
      })
      .catch((err) => {
        console.error("Download failed:", err);
        alert("Failed to download attachment");
      });
  };

  const [activeTab, setActiveTab] = useState("details");
  const [activePsTab, setActivePsTab] = useState("uploaded");

  // Drag and drop handlers for Recce Images
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      fileInputRef.current.files = files;
      // Trigger change event to upload
      fileInputRef.current.dispatchEvent(new Event("change", { bubbles: true }));
    }
  };

  const [recLoading, setRecLoading] = useState(``);
  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files.length > 0) {
      setRecLoading(`<div class="text-blue-500 font-semibold py-4 loadingmess">Please wait. File upload in progress...</div>`);
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("recces", files[i]);
      }
      axios
        .post(Utils.apiUrl(`photoshoot/recces/${id}`), formData, Utils.apiHeaders())
        .then((res) => {
          setRecLoading('');
          if (res.data.success) {
            updateRecceImages();
            alert(res.data.message);
          } else {
            alert(res.data.message);
          }
          // Optionally, show success message or update UI
        })
        .catch((err) => {
          console.error("Upload failed:", err);
          // Optionally, show error message
        });
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };
  //updateRecceImages();

  const deleteUplodedFile = (id) => {
    //if(confirm("Are you sure you want to delete this file?")) {
    axios
      .delete(Utils.apiUrl(`photoshoot/recce/${id}`), Utils.apiHeaders())
      .then((res) => {
        console.log(res.data);
        if (res.data.success) {
          alert(res.data.message);
          updateRecceImages();
        } else {
          alert(res.data.message);
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
    //}
  };

  /* Photoshoot Images Listing */
  const [photoshootImages, setPhotoshootImages] = useState([]);
  const [photoshootFiles, setPhotoshootFiles] = useState([]);
  const updatePhotoshootImages = () => {
    axios
      .get(Utils.apiUrl(`photoshoot/photos?psid=${id}`), Utils.apiHeaders())
      .then((res) => {
        console.log(res.data);
        if (res.data.success) {
          setPhotoshootImages(res.data.data);
          setPhotoshootFiles(_.groupBy(res.data.files, "photo_ids"));
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  };

  /* For deleting uploaded photoshoot file */
  const deletePhotoshootFile = (id) => {
    //if(confirm("Are you sure you want to delete this file?")) {
    axios
      .delete(Utils.apiUrl(`photoshoot/photo/${id}`), Utils.apiHeaders())
      .then((res) => {
        console.log(res.data);
        if (res.data.success) {
          alert(res.data.message);
          updatePhotoshootImages();
        } else {
          alert(res.data.message);
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
    //}
  };

  // Drag and drop handlers for Photoshoot Images
  const handleDragOverPh = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeavePh = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDropPh = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      fileInputRef.current.files = files;
      // Trigger change event to upload
      fileInputRef.current.dispatchEvent(new Event("change", { bubbles: true }));
    }
  };

  const [psLoading, setPsLoading] = useState(``);
  const handleFileChangePh = (e) => {
    const files = e.target.files;
    if (files.length > 0) {
      setPsLoading(`<div class="text-blue-500 font-semibold py-4 loadingmess">Please wait. File upload in progress...</div>`);

      const formDataPh = new FormData();
      for (let i = 0; i < files.length; i++) {
        formDataPh.append("photos", files[i]);
      }
      axios
        .post(Utils.apiUrl(`photoshoot/photos?psid=${id}`), formDataPh, Utils.apiHeaders())
        .then((res) => {
          setPsLoading('');
          if (res.data.success) {
            updatePhotoshootImages();
            alert(res.data.message);
          } else {
            alert(res.data.message);
          }
          // Optionally, show success message or update UI
        })
        .catch((err) => {
          console.error("Upload failed:", err);
          // Optionally, show error message
        });
    }
  };

  const handleClickPh = () => {
    fileInputRefPh.current.click();
  };

  const approvedImages = (pr_status) => {
    return photoshootImages.filter((item) => item.status === "bt-approved" && (pr_status==0 || item.pr_status === pr_status));
  }

  return (
    <>
      <div className="container mx-auto p-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">Photoshoot Details</h1>
        <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-2xl font-semibold">{photoshootDetails.title}</h2>
                <div className="text-right">
                    <div className={`${statusClasses[getStatusLabel(photoshootDetails.status)]} inline`}><i className="fa-solid fa-circle"></i> Status: {photoshootDetails.status_label}</div>
                </div>
            </div>
            {/* <p className="text-sm text-gray-500 mt-1 text-right"><span className="font-medium text-gray-800">{photoshootDetails.status_label}</span></p> */}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6 mb-4">
  
                {/* Left Column */}
                <div className="space-y-4">
                    <div className="grid grid-cols-2 gap-2">
                        <span className="text-sm text-gray-500">Type</span>
                        <span className="font-medium text-gray-800">
                            {hotel_types[photoshootDetails.hotel_type]}
                        </span>
                    </div>

                    <div className="grid grid-cols-2 gap-2">
                        <span className="text-sm text-gray-500">Photographer</span>
                        <span className="font-medium text-gray-800">
                            {photoshootDetails.pgname}
                        </span>
                    </div>

                    <div className="grid grid-cols-2 gap-2">
                        <span className="text-sm text-gray-500">Hotel Photography Lead</span>
                        <span className="font-medium text-gray-800">
                            {photoshootDetails.hrname}
                        </span>
                    </div>

                </div>

                {/* Right Column */}
                <div className="space-y-4">

                    
                    <div className="grid grid-cols-2 gap-2">
                        <span className="text-sm text-gray-500">Shoot Date</span>
                        <span className="font-medium text-gray-800">
                            {formatDate(photoshootDetails.date_from)} - {formatDate(photoshootDetails.date_to)}
                        </span>
                    </div>
                    <div className="grid grid-cols-2 gap-2">
                        <span className="text-sm text-gray-500">Recce Completed By</span>
                        <span className="font-medium text-gray-800">
                            {photoshootDetails.recce_end
                            ? formatDate(photoshootDetails.recce_end)
                            : "-"}
                        </span>
                    </div>
                    
                    <div className="grid grid-cols-2 gap-2">
                        <span className="text-sm text-gray-500">Completion Date</span>
                        <span className="font-medium text-gray-800">
                            {photoshootDetails.delivery_date
                            ? formatDate(photoshootDetails.delivery_date)
                            : "-"}
                        </span>
                    </div>

                    
                </div>

            </div>

          {/* <!-- Tabs --> */}
          <div className="mt-6">
            <div className="flex space-x-2 border-b pb-3">
              <button
                className={`tab-btn ${activeTab === "details" ? "active" : "bg-gray-100"}`}
                data-tab="details"
                onClick={() => setActiveTab("details")}
              >
                Shot-list
              </button>
              <button
                className={`tab-btn ${activeTab === "recce" ? "active" : "bg-gray-100"}`}
                data-tab="recce"
                onClick={() => setActiveTab("recce")}
              >
                Recce
              </button>
              <button className={`tab-btn ${activeTab === "sdeck" ? "active" : "bg-gray-100"}`} data-tab="sdeck" onClick={() => setActiveTab('sdeck')}>Styling Deck</button>
              <button
                className={`tab-btn ${activeTab === "photoshoot" ? "active" : "bg-gray-100"}`}
                data-tab="photoshoot"
                onClick={() => setActiveTab("photoshoot")}
              >
                Post Production Image Review
              </button>
              <button className="tabbtn bg-gray-100 text-gray-300" data-tab="" onClick={() => setActiveTab('approvedimages')}>Download Final Images and Document</button>
            </div>

            <div className="mt-6">
              {/* <!-- Tab: Photoshoot Details --> */}
              <div id="tab-details" className={`tab-panel ${activeTab === "details" ? "active" : "hidden"}`}>

                <div className="form-section">
                  <div className="section-heading">
                    <i className="fas fa-paperclip"></i>
                    Shot Lists
                  </div>

                  <div className="form-group">
                    {/* Loop for attachments */}
                    {photoshootDetails.attachments != undefined &&
                      photoshootDetails.attachments.length > 0 &&
                      photoshootDetails.attachments.map((attachment, index) => (
                        <>
                          <div className="attachment-item" onClick={() => downloadAttachment(attachment.id)}>
                            <i className="fas fa-file-alt"></i>
                            <span>Document {index + 1}</span>
                          </div>
                        </>
                      ))}
                    {/* If no attachments uploaded */}
                    {photoshootDetails.attachments != undefined && photoshootDetails.attachments.length == 0 && (
                      <>
                        <div className="attachment-item">No attachments uploaded</div>
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* <!-- Tab: Photoshoot --> */}
              <div id="tab-recce" className={`tab-panel ${activeTab === "recce" ? "active" : "hidden"}`}>
                        <div className="instruction-note mt-4 mb-4">
                            <i className="fas fa-lightbulb mr-2"></i>
                            It is required only for New and Conversion Hotels
                        </div>

                {recLoading && recLoading !== "" && <div dangerouslySetInnerHTML={{ __html: recLoading }} />}
                <div
                  id="drop-zone"
                  className="drop-zone"
                  onClick={handleClick}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                >
                  Drag &amp; Drop files here or click to select
                  <input
                    name="recces"
                    type="file"
                    id="file-input"
                    multiple="multiple"
                    className="hidden"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                  />
                </div>
                <div className="mt-8">
                  <div id="file-grid" className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4">
                    {/* <!-- Tiles will be appended here --> */}
                    {recceImages.length > 0 &&
                      recceImages
                        //.filter(item => item.status === "submitted")
                        .map((item, index) => (
                          <>
                            <div className="relative bg-white rounded-lg overflow-hidden shadow-sm border">
                              <div className="h-40 bg-gray-100 flex items-center justify-center overflow-hidden">
                                <img
                                  src={`${process.env.REACT_APP_API_URL}/photoshoot/recce/thumb/${item.fname}`}
                                  alt=""
                                  className="object-cover w-full h-full"
                                />
                              </div>
                              <div className="p-3">
                                <div className="text-sm font-semibold text-gray-800 truncate" title="">
                                  Image {index + 1}
                                </div>
                              </div>
                              <div className="absolute top-2 right-2 flex space-x-2">
                                <button
                                  className="w-8 h-8 flex items-center justify-center rounded-full text-red-700"
                                  aria-label="Mark approved"
                                  onClick={() => deleteUplodedFile(item.id)}
                                >
                                  <i className="fa-solid fa-x"></i>
                                </button>
                              </div>
                            </div>
                          </>
                        ))}
                  </div>
                </div>
              </div>

              {/* <!-- Tab: Photoshoot Styling Deck --> */}
              <div id="tab-sdeck" className={`tab-panel ${activeTab === "sdeck" ? "active" : "hidden"}`}>
                  <h1 className="text-3xl font-bold text-gray-400 mb-8">Coming Soon</h1>
              </div>

              <div id="tab-photoshoot" className={`tab-panel ${activeTab === "photoshoot" ? "active" : "hidden"}`}>
                
                {psLoading && psLoading !== "" && <div dangerouslySetInnerHTML={{ __html: psLoading }} />}
                <div
                  id="drop-zone"
                  className="drop-zone"
                  onClick={handleClickPh}
                  onDragOver={handleDragOverPh}
                  onDragLeave={handleDragLeavePh}
                  onDrop={handleDropPh}
                >
                  Drag &amp; Drop files here or click to select
                  <input
                    name="photos"
                    type="file"
                    id="file-input"
                    multiple="multiple"
                    className="hidden"
                    ref={fileInputRefPh}
                    onChange={handleFileChangePh}
                  />
                </div>
                <div className="mt-8">
                  {/* Sub Tabs */}
                  <div className="mb-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                      <div>
                        <div className="flex space-x-2" role="tablist" aria-label="Files Tabs">
                          <button
                            className={`files-tab-btn px-4 py-2 rounded bg-gray-100 font-semibold ${activePsTab === "uploaded" ? "active" : "bg-gray-100"}`}
                            data-tab="uploaded"
                            onClick={() => setActivePsTab("uploaded")}
                          >
                            Uploaded{" "}
                            <span className="ml-2 text-sm text-gray-600">({photoshootImages.filter((item) => item.status === "submitted").length})</span>
                          </button>
                          <button
                            className={`files-tab-btn px-4 py-2 rounded bg-gray-100 font-semibold ${activePsTab === "edits" ? "active" : "bg-gray-100"}`}
                            data-tab="edits"
                            onClick={() => setActivePsTab("edits")}
                          >
                            Edits Needed{" "}
                            <span className="ml-2 text-sm text-gray-600">
                              ({photoshootImages.filter((item) => ["ai-processed", "bt-rejected"].some(status => item.status.includes(status))).length})
                            </span>
                          </button>
                          <button
                            className={`files-tab-btn px-4 py-2 rounded bg-gray-100 font-semibold ${activePsTab === "approved" ? "active" : "bg-gray-100"}`}
                            data-tab="approved"
                            onClick={() => setActivePsTab("approved")}
                          >
                            Approved{" "}
                            <span className="ml-2 text-sm text-gray-600">
                              ({photoshootImages.filter((item) => item.status === "bt-approved").length})
                            </span>
                          </button>
                        </div>
                      </div>
                      <div className="text-right text-sm">
                        <div className="block">
                          Initially Uploaded: <span>{photoshootImages.length}</span>
                        </div>
                        <div className="block">
                          Revision Needed: <span>{photoshootImages.filter((item) => ["ai-processed", "bt-rejected"].some(status => item.status.includes(status))).length}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Uploaded Tab */}
                  {activePsTab === "uploaded" && (
                    <>
                      <h2 className="text-2xl font-semibold text-gray-700 mb-4">Uploaded</h2>
                      <div id="file-grid" className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4">
                        {/* <!-- Tiles will be appended here --> */}
                        {photoshootImages.length > 0 &&
                          photoshootImages
                            .filter((item) => item.status === "submitted")
                            .map((item, index) => (
                              <>
                                <div className="relative bg-white rounded-lg overflow-hidden shadow-sm border">
                                  <div className="h-40 bg-gray-100 flex items-center justify-center overflow-hidden">
                                    <img
                                      src={`${process.env.REACT_APP_API_URL}/photoshoot/photo/thumb/${item.fname}`}
                                      alt=""
                                      className="object-cover w-full h-full"
                                    />
                                  </div>
                                  <div className="p-3">
                                    <div className="text-sm font-semibold text-gray-800 truncate" title="">
                                      Pic {index + 1}
                                    </div>
                                  </div>
                                  <div className="absolute top-2 right-2 flex space-x-2">
                                    <button
                                      className="w-8 h-8 flex items-center justify-center rounded-full text-red-700"
                                      aria-label="Mark approved"
                                      onClick={() => deletePhotoshootFile(item.id)}
                                    >
                                      <i className="fa-solid fa-x"></i>
                                    </button>
                                  </div>
                                </div>
                              </>
                            ))}
                      </div>
                    </>
                  )}

                  {/* Edits Needed Tab */}
                  {activePsTab === "edits" && (
                    <>
                      <h2 className="text-2xl font-semibold text-gray-700 mb-4">Edits Needed</h2>
                      {/* <div id="file-grid" className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4"> */}
                      {/* <!-- Tiles will be appended here --> */}
                      {photoshootImages.length > 0 &&
                        photoshootImages
                          .filter((item) => ["ai-processed", "bt-rejected"].some(status => item.status.includes(status)))
                          .map((item, index) => (
                            <>
                              <ul className="space-y-4">
                                <li className="flex items-center bg-white rounded-lg shadow-sm border p-3">
                                  <img
                                    src={`${process.env.REACT_APP_API_URL}/photoshoot/photo/thumb/${item.fname}`}
                                    alt="Pic 1"
                                    className="w-20 h-14 object-cover rounded mr-4"
                                  />
                                  <div className="flex-1">
                                    <div className="font-semibold text-gray-800">Pic {index + 1}</div>
                                    {/* If BT Feedback is not blank */}
                                    {item.bt_feedback != null && item.bt_feedback != "" && (
                                      <div className="text-sm text-gray-600">{item.bt_feedback}</div>
                                    )}
                                    {/* If BT Feedback is blank showing AI Feedback */}
                                    {(item.bt_feedback == null || item.bt_feedback == "") && item.ai_feedback != undefined && (
                                      <>
                                        <div className="text-sm text-gray-600">
                                          {item.ai_feedback != "" &&
                                            (() => {
                                              try {
                                                const parsed = JSON.parse(item.ai_feedback);
                                                return parsed.feedback.map((feedback, index) => <p key={index}>{feedback}</p>);
                                              } catch (e) {
                                                return <p>Invalid AI feedback</p>;
                                              }
                                            })()}
                                        </div>
                                      </>
                                    )}
                                  </div>
                                  <div>
                                    <a
                                      href={`${process.env.REACT_APP_BASENAME}photographer-view-feedback/${id}/${item.id}`}
                                      className="inline-block items-center px-4 py-2 rounded btn"
                                    >
                                      <i className="fa-regular fa-eye"></i> View Details
                                    </a>
                                  </div>
                                </li>
                              </ul>
                            </>
                          ))}
                      {/* </div> */}
                    </>
                  )}

                  {/* Approved Tab */}
                  {activePsTab === "approved" && (
                    <>
                      <h2 className="text-2xl font-semibold text-gray-700 mb-4">Approved</h2>
                      <div className="flex space-x-2" role="tablist" aria-label="Files Tabs">
                        <button
                          className={`files-tab-btn px-4 py-2 rounded bg-gray-100 font-semibold ${filter.pr_status === 1 ? "active" : "bg-gray-100"}`}
                          onClick={() => setFilter({ pr_status: 1 })}
                        >
                          PR Requested{" "}
                          <span className="ml-2 text-sm text-gray-600">({approvedImages(1).length})</span>
                        </button>
                        <button
                          className={`files-tab-btn px-4 py-2 rounded bg-gray-100 font-semibold ${filter.pr_status === 2 ? "active" : "bg-gray-100"}`}
                          onClick={() => setFilter({ pr_status: 2 })}
                        >
                          PR Ready <span className="ml-2 text-sm text-gray-600">({approvedImages(2).length})</span>
                        </button>
                        <button
                          className={`files-tab-btn px-4 py-2 rounded bg-gray-100 font-semibold ${filter.pr_status === 0 ? "active" : "bg-gray-100"}`}
                          onClick={() => setFilter({ pr_status: 0 })}
                        >
                          Approved Images{" "}
                          <span className="ml-2 text-sm text-gray-600">({approvedImages(0).length})</span>
                        </button>
                      </div>


                      {/* <!-- Tiles will be appended here --> */}
                      {filter.pr_status==1 && approvedImages(filter.pr_status).length > 0 && (<>
                        <div id="file-grid" className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4 pt-2">
                          {/* <!-- Tiles will be appended here --> */}
                          {approvedImages(filter.pr_status).length > 0 &&
                            approvedImages(filter.pr_status)
                              .map((item, index) => (
                                <>
                                  <div className="relative bg-white rounded-lg overflow-hidden shadow-sm border">
                                    <div className="h-40 bg-gray-100 flex items-center justify-center overflow-hidden">
                                      <img
                                        src={`${process.env.REACT_APP_API_URL}/photoshoot/photo/thumb/${item.fname}`}
                                        alt=""
                                        className="object-cover w-full h-full"
                                      />
                                    </div>
                                    <div className="p-3">
                                      <div className="text-sm font-semibold text-gray-800 truncate" title="">
                                        Pic {index + 1}
                                      </div>
                                    </div>
                                    {parseInt(item.pr_status)===1 && <div className="p-3 pt-0">
                                        <input
                                          type="checkbox"
                                          id={`pr_ready_${item.id}`}
                                          checked={prReadyIds.includes(item.id)}
                                          onChange={() => handlePrReadyChange(item.id)}
                                        />
                                        <label htmlFor={`pr_ready_${item.id}`} className="ml-2">
                                          PR Ready
                                        </label>
                                      </div>}
                                    {/* <div className="absolute top-2 right-2 flex space-x-2">
                                              <button className="w-8 h-8 flex items-center justify-center rounded-full text-red-700" aria-label="Mark approved" onClick={() => deletePhotoshootFile(item.id)}>
                                                  <i className="fa-solid fa-x"></i>
                                              </button>
                                          </div> */}
                                  </div>
                                </>
                              ))}
                        </div>
                        {filter.pr_status === 1 && <PrRequestUpload psid={id} prReadyIds={prReadyIds} onUploadSuccess={updatePhotoshootImages} />}
                      </>)}

                      {filter.pr_status==2 && _.keys(photoshootFiles).length > 0 &&
                        _.map(photoshootFiles, (psfiles, phids) => {
                            phids = phids.includes('[') ? JSON.parse(phids) : phids.split(',').map(id => parseInt(id.trim()));
                            return (<>
                              <div id="file-grid" className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4 pt-2">
                                {approvedImages(filter.pr_status)
                                  .filter(item => phids.includes(parseInt(item.id)))
                                  .map((item, index) => (
                                      <div className="relative bg-white rounded-lg overflow-hidden shadow-sm border" key={item.id}>
                                          <div className="h-40 bg-gray-100 flex items-center justify-center overflow-hidden">
                                              <img
                                                  src={`${process.env.REACT_APP_API_URL}/photoshoot/photo/thumb/${item.fname}`}
                                                  alt=""
                                                  className="object-cover w-full h-full"
                                              />
                                          </div>
                                          <div className="p-3">
                                              <div className="text-sm font-semibold text-gray-800 truncate" title="">
                                                  Pic {index + 1}
                                              </div>
                                          </div>
                                      </div>
                                  ))}
                              </div>
                                  
                              {psfiles.map((file) => <a href={file.filename} rel="noopener noreferrer" className="inline-flex items-center m-2 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" >
                                  <i className="fas fa-download"></i>
                                  <span>{file.filetype === 1 ? "Usage Rights" : "High Res"}</span>
                              </a>)}

                            </>);
                        })}

                    {filter.pr_status === 0 && 
                      <div id="file-grid" className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4 mt-2">
                        {photoshootImages.length > 0 &&
                          photoshootImages
                            .filter((item) => item.status === "bt-approved")
                            .map((item, index) => (
                              <>
                                <div className="relative bg-white rounded-lg overflow-hidden shadow-sm border">
                                  <div className="h-40 bg-gray-100 flex items-center justify-center overflow-hidden">
                                    <img
                                      src={`${process.env.REACT_APP_API_URL}/photoshoot/photo/thumb/${item.fname}`}
                                      alt=""
                                      className="object-cover w-full h-full"
                                    />
                                  </div>
                                  <div className="p-3">
                                    <div className="text-sm font-semibold text-gray-800 truncate" title="">
                                      Pic {index + 1}
                                    </div>
                                  </div>                                  
                                </div>
                              </>
                            ))}
                      </div>
                    }

                    </>
                  )}
              </div>
              {/* Approved Images All */}
                

              </div>

              {/* <!-- Tab: Usage Rights (placeholder) --> */}
              <div id="tab-usagerights" className={`tab-panel ${activeTab === "usagerights" ? "active" : "hidden"}`}>
                <p className="text-gray-600">Usage rights are not available yet.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PhPhotoshootDetails;
